import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import platform from 'platform';
import React, { useEffect, useRef, useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { fetchUserDetails } from '../../../Utils/PaymentUtils/utils';
import { generateOtp } from '../../../Utils/helper';
import { getPublicUrl } from '../../../appconfig';
import { verifyOtp } from '../../../datafetchers/LoginPopup/verifyOtp';
import TimeLeft from '../../TimeLeft';
import { InputFieldLogin } from '../FirstScreen/styled';
import {
  apiEvent,
  autoFillOtp,
  decodeKwickpassKpToken,
  fireClickedEvent,
  fireLoginEvent,
  fireLoginVerifyEvent,
  verifyEvent,
} from '../utils';
import VerifyAndProceed from './VerifyAndProceed';
import {
  ErrorMsg,
  LoginDesc,
  LoginForm,
  ResendOtp,
  ResentOtpButton,
} from './styled';
import { getWebUserType } from '../../../Utils/getWebUserType';
import { verifyLoginData } from '../../../datafetchers/LoginPopup';

// import { TimeLeft } from "../../LoginModule/";

function EnterOtp(props) {
  const {
    mobileNumber,
    setVerifyOtpScreen,
    sendOtp,
    apiCallTime,
    hashedValue,
    fromAddress,
    fromOrder,
    otpTries,
    setOtpTries,
    setOtpRequested,
    fromConsult,
    setEnabledButton,
    setShowToast,
    setIsDifferentNumber,
    submitHandler,
    needHelp,
    onLoginSuccess,
    showOldLogin,
  } = props;
  const router = useRouter();
  const [retry, setRetry] = useState(false);
  const randomOtp = useRef(generateOtp());
  const [showDisabled, setShowDisabled] = useState(null);
  const [showResend, setShowResend] = useState(false);
  const [invalidOtp, setInvalidOtp] = useState(false);
  const [loaderState, setLoaderState] = useState('');
  const [invalidReason, setInvalidReason] = useState('Invalid OTP entered');
  const [focusClass, setFocusClass] = useState('');
  const enteredOtp = useRef('');
  const currentTimer = useRef('');
  const verifyBtnRef = useRef();
  const publicUrl = getPublicUrl();
  const resend_otp = otpTries >= 3;

  const handleInputChange = (e) => {
    if (e?.target?.value?.length == 4) {
      if (!resend_otp) verifyLogin(e);
    } else {
      setShowDisabled(true);
      if (setOtpRequested) setOtpRequested(true);
    }
  };
  const handleSuccess = async () => {
    const params = new URLSearchParams(window.location.search);
    if (fromOrder) {
      params.delete('fromOrder');
      const addParams = params.length ? +'?' + params : params;
      window.location.replace(publicUrl + `/my-orders` + addParams);
    } else if (needHelp) {
      params.delete('needHelp');
      const addParams = params.length ? +'?' + params : params;
      router.replace('/need-help' + addParams);
    } else if (fromConsult) {
      setVerifyOtpScreen(false);
      setEnabledButton(true);
      setOtpRequested(false);
      setShowToast(true);
      setIsDifferentNumber(false);
      submitHandler();
      setTimeout(() => {
        setShowToast(false);
      }, [2000]);
    } else {
      if (onLoginSuccess) onLoginSuccess();
      else {
        if (platform.name.toLowerCase().includes('safari')) {
          const url = localStorage.getItem('redirectRoute');

          router.replace(url + window.location.search);
          localStorage.removeItem('redirectRoute');
          window.history.go(-1);
        } else {
          router.back();
        }
      }
    }
  };

  const getData = () => {
    const mobile = mobileNumber.current;
    const web_user_id = Cookies.get('web_user_id_react')
      ? Cookies.get('web_user_id_react')
      : null;
    return {
      mobile: mobile,
      web_user_id: web_user_id,
    };
  };

  const verifyLogin = async (e, autoOtp) => {
    const { web_user_id } = getData();
    verifyEvent(mobileNumber.current);
    setLoaderState('loading');

    if (showOldLogin) {
      const res = await verifyOtp(
        mobileNumber.current,
        web_user_id,
        enteredOtp.current.value,
        hashedValue,
        Cookies.get('cart_items'),
      );
      apiEvent('api/webMobileLogin');
      if (res?.success && res?.data) {
        setShowDisabled(false);
        setInvalidOtp(false);
        let encryptedToken = res?.data;
        Cookies.set('lu', encryptedToken, '/');
        Cookies.set('user_guid', encryptedToken, '/');
        // let decryptedToken = crypto.AES.decrypt(
        //     encryptedToken,
        //     "7F6DAD1C5ABFB7498C4C736D174B2",
        // ).toString(crypto.enc.Utf8);
        Cookies.set('token', encryptedToken, {
          expires: 365,
          path: '/',
        });
        fireLoginVerifyEvent('OTP_verified', autoOtp, '');
        let userType = getWebUserType();
        let newUser;
        if (Cookies.get('shopper')) newUser = false;
        else newUser = true;
        const params = {
          userType,
          random: new Date().getTime(),
          newUser,
        };
        setLoaderState('loaded');
        await fetchUserDetails(params);

        handleSuccess();
      } else {
        setOtpTries((prev) => prev + 1);
        if (res?.data != 'Failed') {
          fireLoginEvent('OTP_wrong');
          setShowDisabled(true);
          setInvalidOtp(true);
          setLoaderState('');
          setInvalidReason(res?.data);
        }
      }
    } else {
      const resp = await __KP_LOGIN_SDK_INSTANCE__.kpVerifyOTP({
        phone: mobileNumber.current,
        otp: parseInt(enteredOtp.current.value),
      });
      if (resp.status == 200 && resp?.body?.data?.kpToken) {
        const data = await decodeKwickpassKpToken(resp?.body?.data?.kpToken);
        if (data?.phone) {
          setShowDisabled(false);
          setInvalidOtp(false);
          let api_params = {
            mobile: data.phone,
            web_user_id: web_user_id,
          };
          const resData = await verifyLoginData(api_params);
          apiEvent('api/webMobileLogin');
          let encryptedToken = resData?.data;
          Cookies.set('lu', encryptedToken, '/');
          Cookies.set('user_guid', encryptedToken, '/');
          Cookies.set('token', encryptedToken, {
            expires: 365,
            path: '/',
          });
          fireLoginVerifyEvent('OTP_verified', autoOtp, '');
          let userType = getWebUserType();
          let newUser;
          if (Cookies.get('shopper')) newUser = false;
          else newUser = true;
          const params = {
            userType,
            random: new Date().getTime(),
            newUser,
          };
          setLoaderState('loaded');
          await fetchUserDetails(params);

          handleSuccess();
        } else {
          setOtpTries((prev) => prev + 1);
          fireLoginEvent('OTP_wrong');
          setShowDisabled(true);
          setInvalidOtp(true);
          setLoaderState('');
          setInvalidReason('Something went wrong, please try again');
        }
      } else {
        setOtpTries((prev) => prev + 1);
        fireLoginEvent('OTP_wrong');
        setShowDisabled(true);
        setInvalidOtp(true);
        setLoaderState('');
        setInvalidReason(resp?.message);
      }
    }
  };
  const handleVerifyLogin = (e) => {
    if (resend_otp) {
      enteredOtp.current.value = '';
      sendOtp();
      setInvalidOtp(false);
    } else {
      verifyLogin(e);
    }
  };

  const resendOtp = () => {
    if (currentTimer.current == 0) {
      enteredOtp?.current?.focus();
      setFocusClass('lowOpacity2');
      setTimeout(() => {
        fireClickedEvent('resend_otp');
        setRetry(!retry);
        setShowResend(false);
        setInvalidOtp(false);
        sendOtp();
        setFocusClass('');
      }, 200);
    }
  };
  const clickedEdit = () => {
    setFocusClass('lowOpacity');
    setTimeout(() => {
      setVerifyOtpScreen(false);
      fireLoginEvent('clicked_edit_contact');
      setFocusClass('');
    }, 200);
  };
  useEffect(() => {
    if (hashedValue) {
      autoFillOtp(randomOtp, verifyLogin, apiCallTime);
    }
  }, [hashedValue]);

  useEffect(() => {
    enteredOtp?.current?.focus();
  }, []);

  return (
    <div style={fromConsult ? { width: '90%', margin: 'auto' } : {}}>
      <LoginDesc>
        <div>
          OTP sent to +91{' '}
          <span style={{ fontWeight: '500' }}>{mobileNumber.current}</span>
        </div>

        <img
          className={focusClass}
          onClick={clickedEdit}
          src={images.edit}
          alt=""
        />
      </LoginDesc>
      <LoginForm>
        <form onSubmit={(e) => e.preventDefault()}>
          <InputFieldLogin
            otp
            redBorder={(showDisabled && showDisabled != null) || invalidOtp}
            greenBorder={!showDisabled && showDisabled != null && !invalidOtp}
            readOnly={resend_otp}
          >
            <input
              ref={enteredOtp}
              onChange={handleInputChange}
              maxLength="4"
              placeholder="Enter OTP here"
              autoFocus={true}
              type="text"
              inputMode="numeric"
              name="one-time-code"
              autoComplete="one-time-code"
              id="otp"
              readOnly={resend_otp}
            />
          </InputFieldLogin>
          {invalidOtp ? <ErrorMsg>{invalidReason}</ErrorMsg> : null}

          {!resend_otp ? (
            showResend ? (
              <>
                <ResendOtp>Didn&apos;t receive OTP yet?</ResendOtp>
                <ResentOtpButton className={focusClass} onClick={resendOtp}>
                  Resend OTP
                </ResentOtpButton>
              </>
            ) : (
              <ResendOtp>
                <span> Resend OTP in&nbsp;</span>
                <TimeLeft
                  countTime={30}
                  resend={retry}
                  currentTimer={currentTimer}
                  setShowResend={setShowResend}
                />
                s
              </ResendOtp>
            )
          ) : null}

          <VerifyAndProceed
            verifyBtnRef={verifyBtnRef}
            showDisabled={showDisabled}
            verifyLogin={handleVerifyLogin}
            loaderState={loaderState}
            invalidOtp={invalidOtp}
            resend_otp={resend_otp}
          />
        </form>
      </LoginForm>
    </div>
  );
}

export default EnterOtp;
